<template>
  <div class="party-photos2">
    <el-tabs
      :value="activeParty"
      @input="
        $store.commit('app/SET_ACTIVEINJURED', '0');
        $emit('update:activeParty', $event);
      "
    >
      <el-tab-pane
        v-for="(accidentParty, index) in accidentPartys"
        :key="index"
        :label="'当事人照片-' + (index + 1)"
        :name="index + ''"
      >
        <div class="photoList">
          <div
            v-for="(prop, key) of config"
            :key="key"
            class="photo-wrapper"
          >
            <i
              v-if="accidentParty[key]"
              class="el-icon-close delete-photo"
              @click="accidentParty[key] = ''"
            />
            <el-image
              class="accident-image"
              :src="accidentParty[key]"
              :preview-src-list="[accidentParty[key]]"
            >
              <template #error>
                <div
                  v-loading="prop.loading"
                  :style="{
                    cursor: isDisabled.value ? 'not-allowed' : 'pointer'
                  }"
                  class="required-upload"
                  @click="
                    () => {
                      if (isDisabled.value) {
                        return;
                      }
                      prop.loading = true;
                      capture()
                        .then(base64Str => getfaceInfo(key, base64Str))
                        .then(({ data: url }) => {
                          $set(accidentParty, key, url);
                          if (prop.afterUpload) {
                            return prop.afterUpload(accidentParty, url);
                          }
                        })
                        .finally(() => {
                          prop.loading = false;
                        });
                    }
                  "
                >
                  点击拍照截图
                </div>
              </template>
            </el-image>
            <div class="required-name">
              {{ prop.label }}
            </div>
          </div>
        </div>
        <!-- <injurePhotos
          v-if="checkListData.includes('3')"
          :injured-partys="
            accidentParty.partyDirectIndemnity.accidentWoundedList
          "
        /> -->
        <myDialog :logTitle="'人脸识别信息'" class="faceData" :logHeight="'430px'" :showDialog.sync="faceInfoDialog">
          <el-table :data="faceData" >
            <el-table-column label="选择" width="130" align="center">
              <template slot-scope="scope">
                <el-radio
                  v-model="selectFace"
                  :label="scope.$index"
                  @change.native="radioChange(scope.row)"
                >
                  {{ }}
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column
              label="序号"
              type="index"
              align="center"
              width="130" />
            <el-table-column property="name" label="姓名" align="center" />
            <el-table-column
              property="personId"
              label="身份证"
              align="center"
            />
          </el-table>
          <div class="dialog-footer">
            <span
              class="partyBtn btn1"
              @click="cacleLog"
            >
              取 消
            </span>
            <span
              class="partyBtn btn2"
              @click="chooseFace"
            >
              确 定
            </span>
          </div>
        </myDialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getCarLicenseByPhoto,
  getDrivingLicenseByPhoto,
  getFaceByPhoto,
  getIdCardByPhoto
} from "@/api/common/third-party";
import { upload } from "@/api/common/upload";
import { getInfoByCarLicenseNum } from "@/api/accident/edit";
import myDialog from '@/components/custom/myDialog.vue'
export default {
  components: {myDialog},
  inject: {
    targetRefs: { default: null },
    isDisabled: { default: () => ({ value: false }) },
  },
  props: {
    accidentPartys: {
      type: Array,
      default: () => []
    },
    activeParty: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      faceInfoDialog: false, // 人脸识别身份弹窗选择
      selectFace: "", // 人脸识别选项
      faceData: [], // 人脸数据
      chooseData: "", // 选择的数据
      changeData: "", // 切换当事人时的数据
      config: {
        facePhoto: {
          label: "人脸信息",
          loading: false
        },
        idCardPhoto: {
          label: "身份证",
          loading: false,
          afterUpload: (party, url) => {
            console.log('身份证:',party,url)
            return getIdCardByPhoto(url).then(({ data: { idNum } }) => {
              console.log('[idCardPhoto]url,idNum,',url,idNum)
              if (idNum) {
                // this.$set(party, 'idCardNum', idNum);
                this.$set(
                  this.accidentPartys[Number(this.activeParty)],
                  "idCardNum",
                  idNum
                );
              }
            });
          }
        },
        drivingLicensePhoto: {
          label: "驾驶证",
          loading: false,
          afterUpload: (party, url) => {
            return getDrivingLicenseByPhoto(url).then(
              ({ data: { cardCode } }) => {
                if (cardCode) {
                  // this.$set(party, 'drivingLicenseNum', cardCode);
                  this.$set(
                    this.accidentPartys[Number(this.activeParty)],
                    "drivingLicenseNum",
                    cardCode
                  );
                }
              }
            );
          }
        },
        carLicensePhoto: {
          label: "车牌",
          loading: false,
          afterUpload: (party, url) => {
            console.log("00000", this.accidentPartys[Number(this.activeParty)]);
            return getCarLicenseByPhoto(url).then(({ data: { number } }) => {
              if (number) {
                // this.$set(party, 'carLicenseNum', number);
                this.$set(
                  this.accidentPartys[Number(this.activeParty)],
                  "carLicenseNum",
                  number
                );
                getInfoByCarLicenseNum(number).then(res => {
                  if (res.data.vehicleType) {
                    // this.$set(party, 'carLicenseType', res.data.vehicleType);
                    this.$set(
                      this.accidentPartys[Number(this.activeParty)],
                      "carLicenseType",
                      res.data.vehicleType
                    );
                  }
                });
              }
            });
          }
        }
      }
    };
  },
  computed: {
    previewSrcList() {
      return Object.keys(this.config)
        .map(key => this.accidentPartys[this.activeParty * 1][key])
        .filter(Boolean);
    }
  },
  // watch:{
  //   activeParty(val) {
  //     this.changeData = this.accidentPartys[Number(val)]
  //   }
  // },
  methods: {
    upload,
    capture() {
      return this.targetRefs.video.screenShot();
    },
    getfaceInfo(key, url) {
      if (key === "facePhoto") {
        getFaceByPhoto({ photo: url })
          .then(res => {
            // console.log(res);
            if (res.code === 0 && res.data.length) {
              this.faceData = res.data;
              this.faceInfoDialog = true;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
      return upload({ fileName: "xxx.png", base64Str: url });
    },
    radioChange(data) {
      this.chooseData = data;
    },
    chooseFace() {
      this.selectFace = "";
      this.faceInfoDialog = false;
      if (this.chooseData && Object.keys(this.chooseData).length) {
        this.$set(
          this.accidentPartys[Number(this.activeParty)],
          "name",
          this.chooseData.name
        );
        this.$set(
          this.accidentPartys[Number(this.activeParty)],
          "idCardNum",
          this.chooseData.personId
        );
        this.$set(
          this.accidentPartys[Number(this.activeParty)],
          "drivingLicenseNum",
          this.chooseData.personId
        );
      }
    },
    cacleLog() {
      this.faceInfoDialog = false;
      this.chooseData = '';
      this.selectFace = '';
    }
  }
};
</script>
<style lang="less">
.party-photos2 {
  .el-tabs__header {
    margin-bottom: 10px;
  }
  .photoList {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
  }
  .photo-wrapper {
    margin-bottom: 10px;
    width: 180px;
    .accident-image {
      width: 180px;
      height: 120px;
      border-radius: 2px;

      .required-upload {
        background: #0B2756;
        font-size: 16px;
        font-weight: 400;
        color: #17ecfe;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }

    .required-name {
      font-size: 12px;
      font-weight: 400;
      margin-top: 5px;
      text-align: center;
      color: #17ECFE;
    }

    .delete-photo {
      cursor: pointer;
      display: none;
      position: absolute;
      right: 5px;
      top: -2px;
      font-weight: 500;
      font-size: 22px;
      z-index: 10;
      color: #ff4949;
    }
    position: relative;

    &:hover {
      .delete-photo {
        display: block;
      }
    }
  }
  .capture {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 2px;
    font-size: 16px;
    font-weight: 400;
    color: #226eff;
    margin-top: -2px;
  }
  .el-tabs__header {
    display: none;
  }
}
.faceData {
  .el-table .el-table__header-wrapper th, .el-table .el-table__fixed-header-wrapper th {
    background-color: rgba(0, 159, 255, 0.2);
    height: 60px;
    color: #7CAFFF;
  }
  .el-table tr {
    color: #7CAFFF;
    height: 60px;
  }
  .dialog-footer {
    margin-top: 45px;
    text-align: center;
    .partyBtn {
      display: inline-block;
      width: 160px;
      height: 48px;
      line-height: 48px;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
      font-size: 20px;
    }
    .btn1 {
      color: #B1E3FF;
      background: rgba(0, 132, 255, 0.1);
      border: 1px solid #0084FF;
      margin-right: 15px;
    }
    .btn2 {
      color: #0EBD35;
      background: rgba(14, 189, 53, 0.1);
      border: 1px solid #0EBD35;
    }
  }
}
</style>
